import React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import ContentLibrary from '../ContentLibrary';
import { FileResult } from '@horasys/bellplus/common/types';
import { AdvertisementState } from 'Stores/Slices/advertisementSlice';
import { useAppSelector } from 'Stores/Hooks/hooks';
import { RootState } from 'Stores/store';

const PREFIX = 'ContentLibraryModal';

const classes = {
    appBar: `${PREFIX}-appBar`,
    title: `${PREFIX}-title`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.appBar}`]: {
		position: 'relative',
	},

    [`& .${classes.title}`]: {
		marginLeft: theme.spacing(2),
		flex: 1,
	}
}));

const Transition: any = React.forwardRef(function Transition(props: any, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});
interface FileDataInterface {
	assetUrl: string;
	assetId: number;
	fileName: string;
	folderId: number;
	id: number;
	userId: string;
	isSelected?: boolean;
	duration: number;
	type?: string;
}
type FilterAssetType = 'video' | 'image' | 'all';
interface Props {
	handleUploadComplete: any;
	mediaType: FilterAssetType;
	disabled: boolean;
}
function ContentLibraryModal(props: Props) {
	const { handleUploadComplete, mediaType, disabled } = props;


	const [open, setOpen] = React.useState(false);

	const [isFileSelected, setIsFileSelected] = React.useState<boolean>(false);
	const advertisementStore: AdvertisementState = useAppSelector(
		(root: RootState) => root.advertisement,
	);

	const { advertisement } = advertisementStore;
	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleSelectFiles = (files: Array<FileDataInterface>) => {
		const selectedFiles: Array<FileDataInterface> = files.filter(
			(file: FileDataInterface) => {
				return file.isSelected && file.isSelected === true;
			},
		);

		let assetFile: FileDataInterface;
		if (selectedFiles.length > 0) {
			assetFile = selectedFiles[0];

			const fileResult: FileResult = {} as FileResult;
			fileResult.duration = assetFile.duration ? assetFile.duration : 0;
			fileResult.fileName = assetFile.fileName;
			fileResult.id = assetFile.assetId;
			fileResult.mediaType = assetFile.type ? assetFile.type : 'image';
			fileResult.uploadStatus = 'uploaded';
			fileResult.url = assetFile.assetUrl;
			fileResult.source = 'content-library';
			setIsFileSelected(true);
			handleUploadComplete(fileResult);
			setOpen(false);
		}
	};

	return (
        <Root>
			{!isFileSelected && (
				<>
					<Typography>or Select from </Typography>
					<Button variant="contained" disabled={disabled} color="primary" style={{backgroundColor:'#042630'}} onClick={handleClickOpen}>
						{' '}
						SELECT FROM LIB{' '}
					</Button>{' '}
				</>
			)}
			<Dialog
				fullWidth={true}
				maxWidth="lg"
				open={open}
				onClose={handleClose}
				TransitionComponent={Transition}>
				<AppBar className={classes.appBar} style={{backgroundColor:"#042630"}}>
					<Toolbar>
						<IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                            size="large">
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							Content Library
						</Typography>
					</Toolbar>
				</AppBar>
				{/* <Typography>Content Library</Typography> */}
				<ContentLibrary
					isSelectable={true}
					onSelectFiles={handleSelectFiles}
					mediaAssetType={mediaType}
					adClientId={advertisement.client.id ? advertisement.client.id : 0}
					adClient={advertisement.client.id ? advertisement.client : {}}
				/>
			</Dialog>
		</Root>
    );
}

export default ContentLibraryModal;
